/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
import axios from "axios";
import style from './Modal.module.css';
import gstyle from '../../../css/GeneralStyle.module.css';
import Modal from './Modal';
import * as useJwt from '../../../auth/jwt/useJwt.js';
import jwtDefaultConfig from '../../../auth/jwt/jwtDefaultConfig';
import { toast } from 'react-toastify';
import { Button } from 'antd';
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_JA } from 'material-react-table/locales/ja';
import { createTheme, ThemeProvider, useTheme } from '@mui/material';
import { jaJP } from '@mui/material/locale';

const RotModal = props => {

    const userData = JSON.parse(useJwt.getUserData());

    const theme = useTheme();

    const columns = [
        {
            id: 'warehouse_name',
            accessorKey: 'warehouse_name',
            enableColumnActions: false,
            header: '倉庫名',
            size: 40
        },
        {
            id: 'item_code',
            accessorKey: 'item_code',
            enableColumnActions: false,
            header: '品番コード',
            size: 40
        },
        {
            id: 'item_a_code',
            accessorKey: 'item_a_code',
            enableColumnActions: false,
            header: '補助コード',
            size: 20
        },
        {
            id: 'rot_code',
            accessorKey: 'rot_code',
            enableColumnActions: false,
            header: 'ロットコード',
        },
        {
            id: 'rot_name',
            accessorKey: 'rot_name',
            enableColumnActions: false,
            header: '名称',
            Cell: ({ row }) => (
                <div style={{ display: 'flex' }}>{row.original.rot_name}</div>
            ),
        },
        {
            id: 'amount',
            accessorKey: 'amount',
            enableColumnActions: false,
            header: '現在残',
            size: 40
        },
        {
            id: 'slip_date',
            accessorKey: 'slip_date',
            enableColumnActions: false,
            header: '入庫日',
            size: 40
        },
    ];

    const [loaded, setLoaded] = useState(false);

    const style_label_wrap = [gstyle.cs_label, gstyle.cs_flex_2];
    const style_select_40 = [gstyle.cs_select, gstyle.w40];
    const style_input_50 = [gstyle.cs_input, gstyle.w50, gstyle.cs_bl_n];

    const [SearchFieldType, setSearchFieldType] = useState(0);
    const handleChangeSearchFieldType = (event) => {
        setSearchFieldType(event.target.value);
    }
    const handleChangeSearchValue = (event) => {
        props.onChange(event.target.value);
    }

    const handleKeyDown = (event) => {
        if (event.keyCode === 13) {
            searchData();
        }
    }

    const searchData = () => {
        let data = {};
        data['userID'] = userData['id'];
        if (SearchFieldType == 0) {
            data['rot_code'] = props.SearchValue;
            if (props.SearchValue2 != "") {
                data['shipper_code'] = props.SearchValue2;
            }
            if (props.SearchValue3 != "") {
                data['item_code'] = props.SearchValue3;
            }
            if (props.SearchValue4 != "") {
                data['item_a_code'] = props.SearchValue4;
            }
        } else if (SearchFieldType == 1) {
            data['item_name'] = props.SearchValue;
        } else {
            data['item_name_kana'] = props.SearchValue;
        }
        if (document.getElementById("RotFilterByLike").checked) {
            data['filterByLike'] = 1;
        } else {
            data['filterByLike'] = 0;
        }
        if (props.warehouseCompany) {
            data['warehouse_company_id'] = props.warehouseCompany;
        }

        if (props.warehouseCode && props.inOutFlag != "1") {
            data['warehouse_code'] = props.warehouseCode;
        }

        let url = jwtDefaultConfig.backendUrl + jwtDefaultConfig.getMstRotStockEndpoint;

        if (props.url) {
            url = props.url
        }
        setLoaded(true);
        props.setTableData([]);
        axios
            .post(url, data, {
                headers: {
                    Authorization: "Bearer " + useJwt.getToken(),
                },
            })
            .then((response) => {
                setLoaded(false);
                if (response.status == 200) {
                    if (response.data.data.length > 0) {
                        props.setTableData(response.data.data);
                    }
                    if (response.data.data.length == 0) toast.error("検索結果はありません。", { autoClose: 3000 });
                }
            })
            .catch((error) => {
                setLoaded(false);
                toast.error("検索結果はありません。", { autoClose: 3000 });
            });
    }
    const handleChangeData = (rot_data) => {
        props.target(rot_data, props.targetParam != null ? props.targetParam : '');
        props.onClose(true);
    }

    return (
        <Modal title="ロット別在庫" show={props.show} onClose={props.onClose} width={props.width}>
            <div className={gstyle.hyfiled}>
                <div className={style.cs_tbl} style={{ minHeight: 610 }}>
                    <ThemeProvider theme={createTheme(theme, jaJP)}>
                        <MaterialReactTable
                            columns={columns}
                            data={props.tableData}
                            enableTopToolbar={true}
                            enableSelectAll={false}
                            enableGlobalFilter={true}
                            enableColumnFilters={false}
                            initialState={{
                                showColumnFilters: true,
                                showGlobalFilter: true,
                            }}
                            localization={MRT_Localization_JA}
                            muiTableBodyProps={{
                                sx: {
                                    '& tr:nth-of-type(odd)': {
                                        backgroundColor: '#f5f5f5',
                                        border: '1px solid #e0e0e0',
                                    },
                                    'td' : {
                                        padding: '0.4rem'
                                    }
                                },
                            }}
                            muiTableBodyCellProps={{
                                sx: {
                                    border: '1px solid #e0e0e0',
                                    textAlign: 'center'
                                },
                            }}
                            muiTableHeadCellProps={{
                                sx: {
                                    border: '1px solid #e0e0e0',
                                    '.Mui-TableHeadCell-Content': {
                                        display: 'flex',
                                        justifyContent: 'center',

                                    },
                                    backgroundColor: '#cfcfcf'
                                }
                            }}
                            muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => {
                                    handleChangeData(row.original);
                                },
                                sx: {
                                    cursor: 'pointer',
                                },
                            })}
                            renderTopToolbarCustomActions={({ table }) => (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label className={style_label_wrap.join(" ")}>
                                        <div className={gstyle.cs_flex}>
                                            <select className={style_select_40.join(" ")} id="SearchFieldType"
                                                value={SearchFieldType}
                                                onChange={handleChangeSearchFieldType}>
                                                <option value="0">コード</option>
                                                <option value="1">名称</option>
                                            </select>
                                            <input type={'text'} className={style_input_50.join(" ")}
                                                value={props.SearchValue} onKeyDown={handleKeyDown}
                                                onChange={handleChangeSearchValue} />
                                        </div>
                                    </label>
                                    <Button onClick={searchData} loading={loaded} type={'primary'} style={{ marginLeft: 30, width: 120, height: 35, borderRadius: 'unset' }}>
                                        {loaded ? '検索中' : '検索'}
                                    </Button>
                                    <label className={gstyle.cs_label}>
                                        <div className={gstyle.cs_flex}>
                                            <input type={"checkbox"} className={style.cs_input_check} id="RotFilterByLike" />
                                            <span>部分検索</span>
                                        </div>
                                    </label>
                                </div>
                            )}
                        />
                    </ThemeProvider>
                </div>
            </div>
        </Modal>
    )
}
export default RotModal;




